import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./Navbar.css";

interface NavbarProps {
  update?: boolean;
  backButton?: boolean;
  lightTheme?: boolean;
  onRefresh?: () => void;
  hideLogo?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({
  update,
  backButton,
  lightTheme,
  onRefresh,
  hideLogo,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  const handleLogout = async () => {
    try {
      await signOut();
      closeMenu();
    } catch (error) {
      console.error("Errore durante il logout:", error);
    }
  };

  const fillColor = lightTheme ? "#FFFFFF" : "#4260D1";

  return (
    <>
      <div className="nav" style={{ marginBottom: "1rem" }}>
        {backButton && !update && (
          <button className="back-button" onClick={handleBack}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke={fillColor}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
        <svg
          className="burger-menu"
          width="30"
          height="25"
          viewBox="0 0 30 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={toggleMenu}
        >
          <path
            d="M0 4.6875C0 3.82324 0.957589 3.125 2.14286 3.125H27.8571C29.0424 3.125 30 3.82324 30 4.6875C30 5.55176 29.0424 6.25 27.8571 6.25H2.14286C0.957589 6.25 0 5.55176 0 4.6875ZM0 12.5C0 11.6357 0.957589 10.9375 2.14286 10.9375H27.8571C29.0424 10.9375 30 11.6357 30 12.5C30 13.3643 29.0424 14.0625 27.8571 14.0625H2.14286C0.957589 14.0625 0 13.3643 0 12.5ZM30 20.3125C30 21.1768 29.0424 21.875 27.8571 21.875H2.14286C0.957589 21.875 0 21.1768 0 20.3125C0 19.4482 0.957589 18.75 2.14286 18.75H27.8571C29.0424 18.75 30 19.4482 30 20.3125Z"
            fill={fillColor}
          />
        </svg>
        {!hideLogo && (
          <img
            className={`logo-unitiva ${lightTheme ? "logo-light" : ""}`}
            src="/assets/logo-wordmark.svg"
            alt="Unitiva Logo"
            width={120}
            height={40}
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        )}
        {update && (
          <div
            className="update-button"
            onClick={handleRefresh}
            aria-label="Aggiorna classifica"
          >
            <img
              src="/assets/ranking/button-refresh.png"
              alt="Update Ranking"
              width={30}
              height={30}
              onClick={handleRefresh}
              aria-label="Aggiorna classifica"
            />
          </div>
        )}
      </div>

      {/* Overlay */}
      {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}

      {/* Side Menu */}
      <div className={`side-menu ${isMenuOpen ? "open" : ""}`}>
        <button className="close-button" onClick={closeMenu}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#4260D1"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <nav className="menu-items">
          <Link to="/" className="menu-item" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/regole" className="menu-item" onClick={closeMenu}>
            Regole del gioco
          </Link>
          <Link to="/ranking" className="menu-item" onClick={closeMenu}>
            Classifica
          </Link>
          <Link to="/termini" className="menu-item" onClick={closeMenu}>
            Termini e condizioni
          </Link>
          <Link to="/contatti" className="menu-item" onClick={closeMenu}>
            Contatti
          </Link>
          {user && (
            <button className="menu-item logout-button" onClick={handleLogout}>
              Logout
            </button>
          )}
        </nav>
      </div>
    </>
  );
};

export default Navbar;
